import { isEncrypted } from '@pdfsmaller/pdf-decrypt';
import { encryptPdfWithFallbacks } from '../shared/pdfEncryptUtils';

/**
 * Restrict a PDF with an owner password + permission flags.
 * The user password stays empty, so the file opens freely but
 * printing/copying/editing are locked behind the owner password.
 *
 * @param {File} file
 * @param {string} ownerPassword
 * @param {{ allowPrint: boolean, allowCopy: boolean, allowModify: boolean, allowAnnotate: boolean, allowForms: boolean }} perms
 * @returns {Promise<Blob>}
 */
export async function applyPdfPermissions(file, ownerPassword, perms) {
    const bytes = new Uint8Array(await file.arrayBuffer());

    const info = await isEncrypted(bytes);
    if (info.encrypted) throw new Error('alreadyEncrypted');
    if (!ownerPassword) throw new Error('emptyPassword');

    const restricted = await encryptPdfWithFallbacks(bytes, '', {
        ownerPassword,
        allowPrinting: perms.allowPrint,
        allowHighQualityPrint: perms.allowPrint,
        allowCopying: perms.allowCopy,
        allowExtraction: perms.allowCopy,
        allowModifying: perms.allowModify,
        allowAnnotating: perms.allowAnnotate,
        allowFillingForms: perms.allowForms,
        allowAssembly: perms.allowModify,
    });

    return new Blob([restricted], { type: 'application/pdf' });
}
